<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Allgemein">
      <template #actions>
        <region-chooser
          v-if="$store.getters['auth/isSuperAdmin']"
          @region:chosen="loadSettings"
        ></region-chooser>
      </template>
      <region-general-settings-form
        :loading="loading"
        :settings="settings"
        :form-submitted="saveSettings"
        @image-uploaded="addImage"
      ></region-general-settings-form>
    </page-content>
  </div>
</template>

<script>
import Vue from "vue"
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import RegionChooser from "@/components/RegionChooser"
import RegionRepository from "@/repositories/region_repository.js"
import RegionGeneralSettingsForm from "@/components/forms/RegionGeneralSettingsForm"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

export default {
  metaInfo: {
    title: "Allgemeine Einstellungen"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    RegionChooser,
    RegionGeneralSettingsForm
  },
  mixins: [ApiErrorHandlerMixin],
  data() {
    return {
      loading: false,
      settings: {}
    }
  },
  async created() {
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      this.loading = true

      try {
        let data = await RegionRepository.getSettings()
        this.settings = data
        this.loading = false
      } catch (error) {
        this.loading = false
        this.handleApiError(error)
      }
    },
    async saveSettings(settings) {
      await RegionRepository.updateGeneralSettings(settings)
    },
    async addImage({ settings, signed_id, command }) {
      try {
        settings.welcome_message_images.push(signed_id)
        let response = await RegionRepository.updateSettings(settings)
        Vue.set(
          this.settings,
          "welcome_message_images",
          response.region.welcome_message_images
        )
        Vue.set(
          this.settings,
          "welcome_message_image_attachments",
          response.region.welcome_message_image_attachments
        )
        let attachment = this.settings.welcome_message_image_attachments.find(
          a => a.blob_signed_id === signed_id
        )
        command({
          src: `${process.env.VUE_APP_ROOT_API}/regions/image_proxy/${attachment.id}`
        })
      } catch (error) {
        this.handleApiError(error, "Fehler beim Hochladen vom Bild")
      }
    }
  }
}
</script>
